import { Injectable } from '@angular/core';

@Injectable()
export class TogglePasswordService {

  constructor() {}

  /**
   * @param e
   */
  toggle(e) {
    e.preventDefault();
    const wrap = e.target.parentElement;
    const inp = wrap.querySelector('input');
    if (inp.getAttribute('type') === 'password') {
      inp.setAttribute('type', 'text');
      e.target.innerHTML = 'Masquer';
    } else {
      inp.setAttribute('type', 'password');
      e.target.innerHTML = 'Voir';
    }
  }
}
